<template>
  <div>
    <div class="pl-7 pt-4">
      <div class="font-secundaria headline font-weight-bold fontColor1--text">ADMINISTRAÇÃO</div>

      <div style="line-height: 8px;" class="font-secundaria subtitle-2 fontColor1--text" v-if="!$vuetify.breakpoint.xs">
        Home > Administração > <span class="font-weight-bold"> {{ tabName }} </span>
      </div>
    </div>

    <CardAdministracao @name="(value) => (tabName = value)" />
  </div>
</template>

<script>
import CardAdministracao from './Shared/CardAdministracao'

export default {
  components: { CardAdministracao },
  data() {
    return {
      tabName: 'E-mail Áreas'
    }
  }
}
</script>

<style></style>
